import { FC } from 'react';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';

import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import OperationDetailsTable from './OperationDetailsTable';

const OperationDetailsDataTab: FC = () => {
  const { data, actions } = useOperationDetailsPage();

  return (
    <div>
      <OperationDetailsTable />

      {data.isIndependentOperation && !data.isOldOperation && (
        <DataTablePagination
          itemPerPage={data.rowsPerPage || 10}
          totalItems={data.totalPartners || 0}
          paginate={actions.handleChangePage}
          currentPage={data.currentPage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          customItemPerPage={0}
          setRowsPerPage={() => {}}
        />
      )}
    </div>
  );
};

export default OperationDetailsDataTab;
